import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import ServiceSalesSequences from "../../images/sales-sequences.png";
import ServiceWorkflowAutomation from "../../images/workflow-automation.png";
import ServiceBulkCampaigns from "../../images/bulk-campaigns.png";
import IconSalesSequences from "../../icons/icon-sales.svg";
import IconWorkflowAutomation from "../../icons/icon-workflow.svg";
import IconBulkCampaigns from "../../icons/icon-bulk-campaigns.svg";

const ServiceTabIntro = (props) => {

  const [itemIsActive, setitemIsActive] = useState(1);
  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    const timer = () => setTimeout(() => {
      const active = itemIsActive >= 3 ? 1 : itemIsActive + 1;
      setitemIsActive(active);
    }, 4000);
    let timerId = null;
    timerId = timer();
    window.addEventListener("resize", setValues);
    document.addEventListener("load", setValues);
    return () => {
      window.removeEventListener("resize", setValues);
      document.removeEventListener("load", setValues);
      clearTimeout(timerId);
    };
  }, [itemIsActive]);

  const { title, tabItems, serviceMediaOne, serviceMediaTwo, serviceMediaThree } = props.data;
  return (
    <div className="cs-service-tab-section section-gap">
      <div className="container">
        <div className="cs-service-tab-info section-gap">
          <h2 className="h3">{title}</h2>
          <p>Timely follow-ups and consistent engagement are key drivers of sales growth. During our research, we found that sales reps spend a ton of time writing personalized emails and follow-ups, assigning leads, figuring out the next actions, and performing mindless tasks that can be better handled by smart and automated software.</p>

          <p>With multiple research and design sessions, we devised and built a suite of features that can enable sales teams to save time from follow-ups and busywork. We also enabled each sales rep to use the best practices from outreach, follow-ups, calling scripts, and email messages, which effectively resulted in more customers and booked revenue per rep.</p>
        </div>
        {isMobile && <>
          <Accordion preExpanded={['a']}>
            <AccordionItem uuid="a" >
              <AccordionItemHeading>
                <AccordionItemButton>
                  <div className="cs-service-tab-item d-flex">
                    <i className="item-icon">
                      <IconSalesSequences />
                    </i>
                    <div className="cs-service-tab-detail">
                      <h3 className="h4">Sales Sequences</h3>
                      <p>Build reusable and automated sales cadences & follow-ups</p>
                    </div>
                  </div>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <img src={ServiceSalesSequences} title="Digital Experiences" alt="digital product experiences" className="banner-img-sales" />
              </AccordionItemPanel>
            </AccordionItem>


            <AccordionItem uuid="b">
              <AccordionItemHeading>
                <AccordionItemButton>
                  <div className="cs-service-tab-item d-flex">
                    <i className="item-icon">
                      <IconWorkflowAutomation />
                    </i>
                    <div className="cs-service-tab-detail">
                      <h3 className="h4">Workflow Automation</h3>
                      <p>Create custom automation to update data, assign tasks, send reminders</p>
                    </div>
                  </div>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <img src={ServiceWorkflowAutomation} title="Digital Experiences" alt="digital product experiences" className="service-banner-automation" />
              </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem uuid="c">
              <AccordionItemHeading>
                <AccordionItemButton>
                  <div className="cs-service-tab-item d-flex">
                    <i className="item-icon">
                      <IconBulkCampaigns />
                    </i>
                    <div className="cs-service-tab-detail">
                      <h3 className="h4">Bulk Campaigns</h3>
                      <p>Reach hundreds of prospects with single-click personalized campaigns</p>
                    </div>
                  </div>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <img src={ServiceBulkCampaigns} title="Digital Experiences" alt="digital product experiences" className="service-banner-bulk" />
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        </>}

        {!isMobile && <>
          <div className="row d-flex flex-wrap">
            <div className="col cs-service-tab-link-block">
              <ul className="cs-service-tab-list">
                {tabItems.map((item, i) =>
                  <li key={i} className={"cs-service-tab-item d-flex" + (itemIsActive === (i + 1) ? " active" : "")}
                    onClick={() => { setitemIsActive(i + 1); }}>
                    <i className="item-icon">{item.icon}</i>
                    <div className="cs-service-tab-detail">
                      <h3 className="h4">{item.header}</h3>
                      <p>{item.content}</p>
                    </div>
                  </li>)}
              </ul>
            </div>
            <div className="col cs-service-tab-media-block">
              <div className="cs-service-tab-media-inner">
                <div className={"cs-service-media-item item-one" + (itemIsActive === 1 ? " active" : "")}>
                  {serviceMediaOne.map((item, i) => <img key={i} src={item.source} title="Digital Experiences" alt="digital product experiences" className={item.class} />)}
                </div>

                <div className={"cs-service-media-item item-two" + (itemIsActive === 2 ? " active" : "")}>
                  {serviceMediaTwo.map((item, i) => <img key={i} src={item.source} title="Digital Transformation" alt="digital transformation" className={item.class} />)}
                </div>

                <div className={"cs-service-media-item item-three" + (itemIsActive === 3 ? " active" : "")}>
                  {serviceMediaThree.map((item, i) => <img key={i} src={itemIsActive === 3 ? item.source : undefined} title="data analytics and AI" alt="digital product development services" className={item.class} />)}
                </div>
              </div>
            </div>

          </div>
        </>}
      </div>
    </div>
  );
};

export default ServiceTabIntro;